import type { Editor } from 'slate';
import { Node } from 'slate';
import { toaster } from '@halo/ui-react';

const MAX_LENGTH = 4096;

export function withMaxLengthEditor(editor: Editor) {
  const { apply } = editor;

  editor.apply = (operation) => {
    apply(operation);
    switch (operation.type) {
      case 'split_node':
      case 'insert_text':
      case 'insert_node': {
        isOverflow();
        break;
      }
    }
  };

  function isOverflow() {
    const currentLength = Node.string(editor).length;
    const overflowLength = currentLength - MAX_LENGTH;
    const result = overflowLength > 0;
    if (result) {
      toaster.warning({
        title: `Over limit by ${overflowLength}`,
        id: 'editor_max_input',
        duration: 3000,
      });
    }
    return result;
  }

  return Object.assign(editor, {
    isOverflow,
  });
}
